import { Avatar, Divider, List, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material'
import { Box, Container } from '@mui/system'
import { alertMsg } from '../utils/basicUtils'

const Reportpage = () => {
    return (
        <Container maxWidth="xl">
            <Box flex={5}>
                <Box sx={{ mb: 2, mt: 3 }}>
                    <Typography sx={{ fontSize: { xs: 30, sm: 48 } }}>
                        Reports
                    </Typography>
                </Box>
                {['Mani', "Hari", "Ranjith", 'Mani', "Hari", "Ranjith", 'Mani', "Hari", "Ranjith"].map((name, index) => {
                    return (
                        <List sx={{ width: '100%', bgcolor: 'background.paper' }} key={index}>
                            <ListItemButton alignItems="flex-start" onClick={() => { alertMsg(`Hi I'm ${name}!`); }}>
                                <ListItemAvatar>
                                    <Avatar alt={name} src="/static/images/avatar/3.jpg" />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={name}
                                    secondary={
                                        <>
                                            <Typography
                                                sx={{ display: 'inline' }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                            >
                                                Sandra Adams
                                            </Typography>
                                            {' — Do you have Paris recommendations? Have you ever…'}
                                        </>
                                    }
                                />
                            </ListItemButton>
                            <Divider variant="inset" component="li" />
                        </List>
                    )
                })}

            </Box>
        </Container>

    )
}

export default Reportpage